import { useQuery } from '@tanstack/react-query'

import fetchRequest from './fetch-request'
import { QueryKeys } from './react-query'

import { ApplicationConfigurationViewModel } from '../../types/api'

export default function useGetAppConfigurations() {
    return useQuery<ApplicationConfigurationViewModel>({
        queryKey: QueryKeys.App.AppSettings,
        queryFn: () =>
            fetchRequest({
                method: 'GET',
                serviceName: 'ntl',
                endpoint: `/app/configurations`,
            }),
        staleTime: Infinity,
    })
}
